ux-popover {
  .ux-popover__trigger {
    display: inline;
  }

  .ux-popover__overlay {
    display: none;
    left: 0;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    z-index: var(--ux-popover-z-index, 100);

    &--opening {
      display: block;
      opacity: 0;
      visibility: hidden;
    }

    &--opened {
      display: block;
      opacity: 1;
      transition: opacity .1s ease;
      visibility: visible;
    }
  }

  .ux-popover__container {
    max-width: 100%;
  }
}
